import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface SectionHeadingProps {
  preTitle?: string;
  title: string;
  description?: string;
  centered?: boolean;
  className?: string;
  showPreTitle?: boolean;
  showStepPrefix?: boolean; // Add new prop to control showing "Step 1:" prefix
}

const SectionHeading = ({
  preTitle,
  title,
  description,
  centered = false,
  className,
  showPreTitle = false, // Default set to false, won't show preTitle
  showStepPrefix = false, // Default set to false, won't show Step 1: prefix
}: SectionHeadingProps) => {
  // Add useTranslation, but we don't need to translate here
  // since we expect translated strings to be passed as props
  const { t } = useTranslation();
  
  return (
    <div
      className={cn(
        "max-w-3xl mb-12",
        centered && "text-center mx-auto",
        className
      )}
    >
      {preTitle && showPreTitle && (
        <span className="inline-block text-sm font-sans font-medium text-anzir uppercase tracking-wide mb-2 animate-fade-in">
          {preTitle}
        </span>
      )}
      <h2 
        className={cn(
          "text-3xl md:text-4xl font-bold mb-4 animate-fade-in whitespace-normal break-words font-sans pr-4 py-2 rounded-md",
          centered ? "inline-block" : "text-left block w-full"
        )}
        style={{ animationDelay: "100ms" }}
      >
        {showStepPrefix ? `Step ${preTitle?.split(" ")[1] || "1"}: ` : ""}{title}
      </h2>
      {description && (
        <p 
          className="text-muted-foreground text-lg animate-fade-in whitespace-normal break-words mt-4" 
          style={{ animationDelay: "200ms" }}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
